// Action types for fetching orders
export const FETCH_ORDERS_BY_STATUS_COUNT_REQUEST = "FETCH_ORDERS_BY_STATUS_COUNT_REQUEST";
export const FETCH_ORDERS_BY_STATUS_COUNT_SUCCESS = "FETCH_ORDERS_BY_STATUS_COUNT_SUCCESS";
export const FETCH_ORDERS_BY_STATUS_COUNT_FAILURE = "FETCH_ORDERS_BY_STATUS_COUNT_FAILURE";
export const FETCH_ORDERS_BY_STATUS_COUNT_RESET = "FETCH_ORDERS_BY_STATUS_COUNT_RESET";
// Fetch data actions
export const fetchOrdersByStatusCountRequest = (payload) => ({
    type: FETCH_ORDERS_BY_STATUS_COUNT_REQUEST,
    payload,
});
export const fetchOrdersByStatusCountSuccess = (payload) => ({
    type: FETCH_ORDERS_BY_STATUS_COUNT_SUCCESS,
    payload,
});
export const fetchOrdersByStatusCountFailure = (error) => ({
    type: FETCH_ORDERS_BY_STATUS_COUNT_FAILURE,
    payload: error,
});
export const fetchOrdersByStatusCountReset = () => ({
    type: FETCH_ORDERS_BY_STATUS_COUNT_RESET,
});
